import React, { Component } from 'react'
import delv from "../../assets/delv.svg"
import "./OrderTracking.scss"
import { fallbackImg } from "../../constants/constants";
import { Button, Image, Spin, Select, Checkbox, message } from 'antd';
import { Link } from "react-router-dom";
import { ShowOrderDetails } from '../../network/profile.network';
import next from "../../assets/next.svg"
import confirmed from "../../assets/confirmed.svg"
import current_state from "../../assets/current_state.svg"
import { fetchSubscriptionTypes } from '../../network/product.network';
import { OrderSubscription, OrderUnSubscription } from '../../network/cart.network';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import {
  ArrowLeftOutlined
} from '@ant-design/icons';
export default class OrderTracking extends Component {

    state = {
        orderDetails : null,
        isLoading : false,
        isSubscribeChecked : false,
        types : [],
        selectsubscribe : null,
        dateString : null
    }

    componentDidMount() {
      this.setState({isLoading : true})
        let params = this.props.orderData.id;
        ShowOrderDetails(
          params, 
          (res) => {
            this.setState({orderDetails : res.data.data.order, isLoading : false, dateString : res.data.data.order.nextDate})
            if(res.data.data.order.subscriptionType){
              this.setState({isSubscribeChecked : true, selectsubscribe : res.data.data.order.subscriptionType.id})  
            }
            fetchSubscriptionTypes((res) => {
              console.log(res.data.data.types);
              this.setState({types : res.data.data.types, loading : false, }, () => {
              if(this.state.selectsubscribe === null){ 
                this.setState({selectsubscribe : res.data.data?.types[0]?.id})
              }
            }) 
          }, (error) => {console.log(error); this.setState({loading : false})})  
          },
          (error) => {console.log(error); this.setState({isLoading : false}) } 
        )
    }

    handeldsubscribe = (e) => {
      console.log(e.target.checked)  

      // this.setState({isSubscribeChecked : e.target.checked}) 
      let body = new FormData(); 
      body.append("orderId", this.state.orderDetails?.id);   
      if(e.target.checked){
        if(!this.state.dateString){
          message.warning(this.props.localization.startdatsubscribe[this.props.currentLang]);
          return false; 
        } 
        body.append("subscriptionTypeId", this.state.selectsubscribe);
        body.append("subscriptionDate", this.state.dateString);
          OrderSubscription(  
              body,
              (res) => {
                this.setState({ commentLoading: false });
                if (res.data.code === 200) {
                  message.success(res.data.message);
                  this.setState({isSubscribeChecked : e.target.checked}) 
                }
              },
              (error) => {
                this.setState({ commentLoading: false });
                console.log(error); 
              }
            );
      }else{ 
        OrderUnSubscription( 
              body,
              (res) => {
                this.setState({ commentLoading: false });
                if (res.data.code === 200) {
                  message.success(res.data.message);
                  this.setState({isSubscribeChecked : e.target.checked}) 
                }
              },
              (error) => {
                this.setState({ commentLoading: false });
                console.log(error); 
              }
            );
      }
  }

  disabledDate = (current) => {
    // Can not select days before today and today
    // console.log(moment().day(3).format("YYYY-MM-DD")) 
    return current && current < moment().add(2,'days'); 
  } 
  onChangeDatePicker = (date, dateString) => {
    this.setState({dateString})
  }

  
    
    render() {
        const {orderDetails, isLoading, types, isSubscribeChecked, selectsubscribe, dateString} = this.state; 
        const {localization, currentLang, orderData, showOrderDetails} = this.props;
        console.log(this.props, "orderData props"); 
        return ( 
            <>
            <Spin spinning={isLoading}> 
            <div className="user-order-track"> 

                {showOrderDetails ? 
                <>
                 <Button ghost type="primary" size="large" 
                className="btn-back-holder"
                onClick={() => this.props.showOrderList()}> <ArrowLeftOutlined />{localization.Back[currentLang]} </Button>
                <div className="subscribe-order-wrapper">
                  <div className="subscribe-content-holder">
                      <Checkbox checked={isSubscribeChecked} onChange={ this.handeldsubscribe} >{localization.SubscribeToThisOrder[currentLang]}</Checkbox>
                      <div>
                        {/* {console.log(orderDetails?.nextDate)}  */} 
                      <DatePicker
                          format="YYYY-MM-DD"
                          disabledDate={this.disabledDate} 
                          placeholder={localization.StartFrom[currentLang]} 
                          onChange={this.onChangeDatePicker}
                          // value={moment(dateString ? dateString : moment().format("YYYY-MM-DD"), 'YYYY-MM-DD')}
                        />
                      <Select style={{ width: 125 }} value={selectsubscribe} onChange={(val) => this.setState({selectsubscribe : val })} >
                          { 
                              types?.map(type =>  <Select.Option value={type.id} key={type.id}>{type.name}</Select.Option> ) 
                            }
                      </Select>
                        </div>
                  </div>
            </div> </> : 
                <div className="order-track-header">
                  <div className="back-title">
                  <Button ghost type="primary" size="large" 
                className="btn-back-holder"
                onClick={() => this.props.showOrderList()}> <ArrowLeftOutlined />{localization.Back[currentLang]} </Button>
                    <p className="order-track-title">{localization.Youhaveprocess[currentLang]} </p>
                  </div>
                    <p className="order-deliver-holder">
                    <img src={delv} alt="" />  
                    {localization.orderwillbedelivered[currentLang]} {orderData?.creationDate} 
                    </p>
                    <div className="order-status-wrapper">
                        <div className="order-status-steper">
                            {orderData?.statuses.map(status => 
                            <>
                                <div className="status-card-holder">
                                    {status.value === 0 && 
                                    <img src={next} alt="" />
                                    }
                                    {status.value === 1 && 
                                    <img src={confirmed} alt=""  className="complate-step" />
                                    }
                                    {status.value === 2 && 
                                    <img src={current_state} alt="" className="current-step" /> 
                                    }
                                    <p className="status-card-name">
                                    {status.name} 
                                    </p>
                                </div>  
                                <span className="divider"></span>
                                </>
                            )}
                        </div>
                    </div>
                </div>}

                <div className="order-track-content"> 
                <p className="order-items-title">{localization.Orderitems[currentLang]}</p> 
                <div className="order-items-list"> 
                  {orderDetails?.items?.map(card => 
                  <div className="item-holder" key={card.id}>
                  <div className="product-img">
                  <Link to={`/product/${card?.id}/${card?.productName}`}>  
                    <Image
                      src={card?.image_link || card?.image || fallbackImg}
                      fallback={fallbackImg}
                      preview={false}
                      />
                  </Link>
                  </div>
                  <div className="product-details-wrapper">
                  <div className="product-info"> 
                    <h6 className="product-name">{card?.productName}</h6> 
                    <span className="product-count">x{parseFloat(+card.quantity).toFixed(0)}</span> 
                  </div>

                  <div className="price-holder">
                    <p className="price-after">
                      {card?.amount} <span>{localization.AED[currentLang]}</span> 
                    </p>
                  </div>
                  </div>
                  </div>
                  )}
                </div>
                <div className="cart-aside-card">
                  <h6 className="cart-aside-card--title">{localization.Deliverto[currentLang]}</h6>
                  <div className="aside-card-row"> 
                    <h4 className="card-row-title"> 
                          {orderDetails?.address}
                      </h4> 
                  </div>
                </div>
                <div className="cart-aside-card">
                  <h6 className="cart-aside-card--title">{localization.Paywith[currentLang]}</h6>
                  <div className="aside-card-row"> 
                    <h4 className="card-row-title"> 
                          {orderDetails?.paymentType} 
                      </h4> 
                  </div>
                </div>

                <div className="checkout-total-holder">
                    <div className="total-row">
                      <h4>{localization.Subtotal[currentLang]}</h4> 
                      <h5>{orderDetails?.subtotal}<span>{localization.AED[currentLang]}</span></h5>
                    </div>
                    {orderDetails?.discount !== "0.00" && 
                    <div className="total-row">
                      <h4>{localization.Discount[currentLang]}<span>({localization.Promocodeapplied[currentLang]})</span> </h4>
                      <h5>{parseFloat(+orderDetails?.discountPercentage).toFixed(0)}%</h5>   
                    </div> 
                    }
              </div>  

              <div className="checkout-final-total"> 
              <div className="total-row"> 
                      <h4>{localization.TOTAL[currentLang]}</h4>
                      <h5>{orderDetails?.total}<span>{localization.AED[currentLang]}</span></h5>
                    </div>
                </div>   

                </div> 
            </div> 
            {showOrderDetails ? 
            <Button
            size="large"
            style={{ width: 144 }}  
            type="primary"  
            ghost
            className="cancel-order-btn"
            onClick={() => this.props.handelReorder(orderDetails?.id)}   
        >{localization.Reorder[currentLang]}</Button>  
            : 
            <Button
            size="large"
            style={{ width: 144 }}  
            type="danger" 
            ghost
            className="cancel-order-btn"
            onClick={() => this.props.handelCancelOrder(orderDetails?.id)} 
            >{localization.Cancel[currentLang]}</Button>
          }
            </Spin>
            </>
        )
    }
}
